import { sendRequest } from "@infrastructure/api/api";
import type ApiResponse from "@core/types/apiResponse";
import type { ErrorResponse } from "@core/types/errorResponse";
import type { ReportProcessResult } from "./types";

export type ProcessDepartmentReportArgs =
  | {
      scope: "church";
      churchId: number;
      departmentId: number;
      reportTagId: number;
    }
  | {
      scope: "district";
      districtId: number;
      departmentId: number;
      reportTagId: number;
    }
  | {
      scope: "nation";
      nationId: number;
      departmentId: number;
      reportTagId: number;
    };

function buildPath(args: ProcessDepartmentReportArgs): string {
  if (args.scope === "church") {
    return `/church/${args.churchId}/department/${args.departmentId}/report/reporttag/${args.reportTagId}/process`;
  }

  if (args.scope === "district") {
    return `/district/${args.districtId}/department/${args.departmentId}/report/reporttag/${args.reportTagId}/process`;
  }

  const nationId = args.nationId;
  if (!nationId) {
    throw new Error("nationId is required for scope=nation");
  }

  return `/nation/${nationId}/department/${args.departmentId}/report/reporttag/${args.reportTagId}/process`;
}

export async function processDepartmentReportAsync(
  args: ProcessDepartmentReportArgs
): Promise<ApiResponse<ReportProcessResult, ErrorResponse>> {
  return sendRequest<void, ReportProcessResult>("POST", buildPath(args));
}
